/*
 * This file can be replaced during build by using the `fileReplacements` array.
 * `ng build` replaces `environment.ts` with `environment.prod.ts`.
 * The list of file replacements can be found in `angular.json`.
 */

export const environment = {
  /*
   * ============================================================================
   *   Application Configuration
   * ============================================================================
   */

  production: false,
  appName: 'medicross Patient Onboarding Staging',
  appDescription: 'medicross Patient Onboarding Staging Deployment',
  isDebug: true,

  // TODO: Add the actual Terra App Base URL
  terraAppBaseURL: 'https://uat-medicross-pob.allegra.health/',

  /*
   * ============================================================================
   *   Authentication Configuration
   * ============================================================================
   */

  authority: 'hhttps://login.microsoftonline.com/04d69467-616a-42cb-81b3-708fddefb029/v2.0',
  authWellknownEndpointUrl: 'https://allegrahealth01.b2clogin.com/allegrahealth01.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_ALG_UAT_TERRA_AUTH_SUSI',


  clientId: 'fa1133a5-b453-4e28-abfd-1a4ac32f53a1',

  scope: 'https://allegrahealth01.onmicrosoft.com/alg-uat-terra-api/alg-uat-terra-api',
  resetPasswordFlow: 'b2c_1_allegra_passwordreset',
  updateProfileFlow: 'b2c_1_allegra_admin_profile',


  /*
   * ============================================================================
   *   External Configuration
   * ============================================================================
   */

  // TODO: Add the actual Google API key
  googleApiKey: 'IzaSyDA9X-PsRsKFMN5atzaxdLqzweEKuYpENo',

  /*
   * ============================================================================
   *   API Base URLs
   * ============================================================================
   */

  mpiBaseUrl: 'https://uat-api.allegra.health/mpi',
  mdiBaseUrl: 'https://uat-api.allegra.health/mdi',
  organizationBaseUrl: 'https://uat-api.allegra.health/organization',
  mediaBaseUrl: 'https://uat-api.allegra.health/media',
  practitionerBaseUrl: 'https://uat-api.allegra.health/practitioner',
  authBaseUrl: 'https://uat-api.allegra.health/authorization',
  calendarBaseUrl: 'https://uat-api.allegra.health/calendar',
  ivcsBaseUrl: 'https://uat-api.allegra.health/ivcs',
  healthFindrBaseUrl: 'https://uat-api.allegra.health/terrahfindr',
  pathologyBaseUrl: 'https://uat-api.allegra.health/pathology',
  acsBaseUrl: 'https://uat-api.allegra.health/acs',
  consultationBaseUrl: 'https://uat-api.allegra.health/consultation',


  /*
   * ============================================================================
   *   Localization and Internationalization
   * ============================================================================
   */

  availablelanguages: [
    { code: 'en', text: 'English', dir: 'ltr' },
    { code: 'ar', text: 'عربي', dir: 'rtl' },
  ],

  preferredCountries: ['za', 'us'],

  /*
   * ============================================================================
   *   Secured Routes
   * ============================================================================
   * This section sets which routes will be secure (https://)
   * If you are using a local API with authentication, you should add it here
   */

  secureRoutes: [
    'https://uat-api.allegra.health/',
    // https://localhost:7230/,
  ],

  /*
   * ============================================================================
   *   Constants
   * ============================================================================
   */

  constants: {
    DEMO_CONSTANT: 'demo',
  },

  /*
   * ============================================================================
   *   Feature Flags
   * ============================================================================
   * You can use these flags to enable or disable certain modules in the
   * application based on the environment
   */

  demoModuleEnabled: true,

  // Patient onboarding demo (Allegra staging only): submits to the demo complete endpoint and shows the demo results view.
  enableDemo: false,

  /*
   * ============================================================================
   *   Dynamic Call Options
   * ============================================================================
   */

  dynamicCallOptions: {
    ParticipantNotJoinedTimeout: 10000,
    CallEndTimeout: 3000,
    pollTime: 10000,
  },
};

/*
 * ============================================================================
 *   Development Debugging
 * ============================================================================
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

import 'zone.js/plugins/zone-error';
